import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Master  } from '@providers/asset/index';

@Component({
  selector: 'page-department',
  templateUrl: 'page.html'
})
export class DepartmentPage {

  List: any  = [];
  pilihModal = 0;
  keyword    = '';
  sourceDept = '';

  constructor(
    public navCtrl    : NavController,
    public masterApi  : Master,
    public toastCtrl  : ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl   : ViewController,
    public navParams  : NavParams
  ) {
    this.pilihModal = navParams.get('pilih');
    this.sourceDept = navParams.get('sourceDept');
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(keyword=''){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = { };
    if(keyword!=''){
      params.keyword=keyword;
    }
    if(this.sourceDept=='ops'){
      params.sourceDept='ops';
    }
    this.masterApi.getDepartment(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  select(item){
    let data = { item: item };
    if(this.pilihModal==1){
      this.viewCtrl.dismiss(data);
    }
  }

  onInput(e){
    this.getList(this.keyword);
  }

  onCancel(e){
    this.getList();
  }

  closeModal(){
    let data = {item:''};
    this.viewCtrl.dismiss(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/department/page.ts